// src/features/dashboard/hooks/Employee/useMonthlyProductivity.ts

import {
  useEffect,
  useState,
} from 'react';

import {
  getMonthlyProductivity,
} from '../../services/Employee/monthlyProductivity.service';

import {
  monthlyProductivityMock,
} from '../../mocks/Employee/monthlyProductivity.mock';

import {
  formatPercentage,
  formatTrend,
} from '../../utils/Employee/monthlyProductivity.utils';

import {
  useDashboardDate,
} from '../../context/DashboardDateContext';

import {
  formatApiDate,
} from '../../utils/date.utils';

import type {
  MonthlyProductivityResponse,
} from '../../types/Employee/monthlyProductivity.types';

import { AuthSession } from '../../../../utils/authSession';


export const useMonthlyProductivity = () => {

 const employeeCode = AuthSession.currentEmployee();

  const {
    fromDate,
    toDate,
  } = useDashboardDate();

  const [
    data,
    setData,
  ] =
    useState<MonthlyProductivityResponse | null>(
      null,
    );

  const [
    loading,
    setLoading,
  ] =
    useState(true);

  useEffect(() => {

 if (!employeeCode) {
  return;
}

    const fetchData =
      async () => {

        try {

          setLoading(
            true,
          );

          const response =
  await getMonthlyProductivity({
    employeeCode,
    fromDate:
      formatApiDate(fromDate),
    toDate:
      formatApiDate(toDate),
  });

          setData({
            ...monthlyProductivityMock,

            badgeText:
              `${response.workingDaysConsidered} Working Days`,

            averageProductivity:
              Math.round(
                response.productivityPercentage,
              ),

            metrics: [
              {
                label:
                  'Best day',
                value:
                  formatPercentage(
                    response.bestProductivityPercentage,
                  ),
              },
              {
                label:
                  'Lowest day',
                value:
                  formatPercentage(
                    response.lowestProductivityPercentage,
                  ),
              },
              {
                label:
                  'vs Previous',
                value:
                  formatTrend(
                    response.raiseDipPercentage,
                  ),
                color:
                  response.raiseDipPercentage >= 0
                    ? 'text-[#16A34A]'
                    : 'text-[#DC2626]',
              },
              {
                label:
                  'Org target',
                value:
                  formatPercentage(
                    response.targetProductivityPercentage,
                  ),
              },
            ],
          });

        } catch (
          error
        ) {

          console.error(
            'Monthly Productivity Error:',
            error,
          );

        } finally {

          setLoading(
            false,
          );
        }
      };

    fetchData();

  }, [
    employeeCode,
    fromDate,
    toDate,
  ]);

  return {
    data,
    loading,
  };
};